
import React, { useState } from "react";
  
function Summernote() {
    const [file, setFile] = useState();
    function handleChange(e) {
        console.log(e.target.files);
        setFile(URL.createObjectURL(e.target.files[0]));
    }
  
    return (
        <div className="App">
            <h2>Add Image:</h2>
            <input type="file" onChange={handleChange} />
            {/* <img src={file} /> */}
      <img id="Div2" src={file} width="100" height="100" style={{ paddingTop: "3%" }} ></img>
                                                    <img width="100" height="100" style={{ "display": "none", paddingTop: "3%" }} ></img>
                                                    <img id="Div1" width="100" height="100" style={{ "display": "none", paddingTop: "3%" }} ></img>
                                                    <input type="hidden" name="hiddenfile" />
        </div>
  
    );
}
  
export default Summernote;